import type { UserRole } from "@agent-todo/shared"
import type { Session, User } from "@supabase/supabase-js"
import { createContext } from "react"

export interface UserProfile {
  id: string
  email: string
  role: UserRole
  created_at: string
}

export interface AuthContextType {
  user: User | null
  profile: UserProfile | null
  session: Session | null
  loading: boolean
  isAdmin: boolean
  signIn: (provider: "google" | "github") => Promise<void>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
